module.exports = __webpack_public_path__ + "img/logo.46c42036.jpg";